import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
import { memo } from 'react';

function FundingLatestRepaymentDateForm({ fundingMaxRepaymentDate }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Latest Repayment Date:</Form.Label>
      </Col>
      <Col md={2} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="maxRepaymentDate"
          id="maxRepaymentDate"
          value={
            fundingMaxRepaymentDate
              ? moment.utc(fundingMaxRepaymentDate).local().format('MMM DD, YYYY')
              : ''
          }
          readOnly
        />
      </Col>
    </>
  );
}

export default memo(FundingLatestRepaymentDateForm);
